import React from "react";
import { Button, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import { formatarDataBR } from "./densidadeInSituModel";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import { NOME_EMPRESA_LEGAL } from "../Config/branding";

const ENSAIOS_POR_PAGINA = 5;

function valor(conteudo) {
  return conteudo === null || conteudo === undefined || conteudo === "" ? "-" : conteudo;
}

function celulasEnsaios(ensaios, campo) {
  return ensaios.map((ensaio, index) => <td key={`${campo}-${index}`}>{valor(ensaio[campo])}</td>);
}

function celulasCondicao(ensaios) {
  return ensaios.map((ensaio, index) => (
    <td key={`condicao-${index}`} className="di-condicao">
      <div className="di-condicao-linha">
        <span className="di-check">{ensaio.conforme ? "X" : ""}</span>
        <span>CONFORME</span>
      </div>
      <div className="di-condicao-linha">
        <span className="di-check">{ensaio.naoConforme ? "X" : ""}</span>
        <span>NÃO CONF.</span>
      </div>
    </td>
  ));
}

export default function RelatorioDensidadeInSituPrint({
  dados = {},
  dadosLista = null,
  incluirCapa = false,
  onVoltar,
}) {
  useNomeArquivoPdf(dadosLista?.length === 1 ? dadosLista[0]?.codigo : dados?.codigo);
  const relatorios = dadosLista?.length ? dadosLista : [dados];
  const paginas = relatorios.flatMap((relatorio, relatorioIndex) => {
    const todosEnsaios = relatorio.ensaios?.length ? relatorio.ensaios : [];
    const totalPaginas = Math.max(1, Math.ceil(todosEnsaios.length / ENSAIOS_POR_PAGINA));

    return Array.from({ length: totalPaginas }, (_, pagina) => {
      const inicio = pagina * ENSAIOS_POR_PAGINA;
      const ensaiosPagina = todosEnsaios.slice(inicio, inicio + ENSAIOS_POR_PAGINA);
      return {
        dados: relatorio,
        ensaios: Array.from({ length: ENSAIOS_POR_PAGINA }, (_, index) => ensaiosPagina[index] || {}),
        key: `${relatorio.id || relatorio.codigo || relatorioIndex}-${pagina}`,
        ultimaPagina: relatorioIndex === relatorios.length - 1 && pagina === totalPaginas - 1,
      };
    });
  });

  return (
    <div className="di-print-root">
      <style>{`
        .di-print-root { background: #f5f7fb; min-height: 100vh; padding: 16px; box-sizing: border-box; }
        .di-print-root .no-print { position: fixed; top: 10px; right: 18px; z-index: 20; justify-content: flex-end; background: #f5f7fb; padding: 6px; border-radius: 8px; }
        @media print {
          .di-print-root { background: #fff !important; min-height: auto !important; padding: 0 !important; }
          .di-print-root .no-print { display: none !important; }
        }
      `}</style>
      <Stack className="no-print" direction="row" spacing={1}>
        {onVoltar && (
          <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onVoltar}>
            Voltar
          </Button>
        )}
        <Button variant="contained" startIcon={<PrintIcon />} onClick={() => window.print()}>
          Imprimir
        </Button>
      </Stack>
      {incluirCapa && (
        <CapaRelatorioDensidadeInSitu dados={relatorios[0] || dados} />
      )}
      {paginas.map((pagina) => (
        <RelatorioDensidadeInSituPagina
          key={pagina.key}
          dados={pagina.dados}
          ensaios={pagina.ensaios}
          ultimaPagina={pagina.ultimaPagina}
        />
      ))}
    </div>
  );
}

function CapaRelatorioDensidadeInSitu({ dados = {} }) {
  const dataBase = new Date().toISOString().slice(0, 10);
  const primeiroEnsaio = dados.ensaios?.find((ensaio) => ensaio.localizacao) || {};
  const localRelatorio = dados.endereco || dados.obraEndereco || primeiroEnsaio.localizacao || dados.obra;

  return (
    <div className="di-capa-print">
      <style>{`
        .di-capa-print { page: relatorioDensidadeInSituPrint; }
        @page relatorioDensidadeInSituPrint { size: A4 portrait; margin: 0; }
        .di-capa-print {
          width: 210mm;
          min-height: 297mm;
          margin: 0 auto 10mm;
          padding: 16mm 14mm;
          background: #fff;
          color: #000;
          font-family: Arial, Helvetica, sans-serif;
          box-sizing: border-box;
          page-break-after: always;
          break-after: page;
        }
        .di-capa-moldura {
          min-height: 265mm;
          border: 2mm solid #7f7f7f;
          padding: 18mm 6mm 8mm;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .di-capa-empresa {
          border: 1px solid #9ca3af;
          width: 88mm;
          min-height: 24mm;
          text-align: center;
          padding: 3mm;
          box-sizing: border-box;
          font-size: 8px;
          line-height: 1.3;
        }
        .di-capa-empresa strong {
          display: block;
          color: #5f7289;
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 1.5mm;
        }
        .di-capa-centro {
          width: 100%;
          margin-top: 68mm;
        }
        .di-capa-faixa {
          height: 7mm;
          background: #cfe0f3;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 7mm;
          font-size: 15px;
        }
        .di-capa-faixa span {
          line-height: 1.1;
        }
        .di-capa-subtitulo span {
          min-width: 76mm;
          text-align: center;
        }
        .di-capa-dados {
          width: 100%;
          margin-top: 12mm;
        }
        .di-capa-info {
          display: grid;
          grid-template-columns: 32mm 1fr;
          min-height: 8mm;
          background: #dbe8f6;
          margin-bottom: 4mm;
          align-items: center;
          font-size: 10px;
        }
        .di-capa-info strong {
          justify-self: end;
          padding: 1mm 2mm;
          font-size: 9px;
        }
        .di-capa-info span {
          justify-self: start;
          min-width: 12mm;
          padding: 1mm 2mm;
        }
        .di-capa-rodape {
          margin-top: auto;
          padding: 2mm;
          text-align: center;
          font-size: 8px;
          line-height: 1.25;
          font-weight: 700;
          min-width: 80mm;
        }
        .di-capa-assinatura {
          width: 74mm;
          border-top: 1px solid #000;
          margin: 0 auto 1mm;
          padding-top: 1mm;
        }
        .di-capa-assinatura-img {
          display: block;
          width: 36mm;
          max-height: 12mm;
          object-fit: contain;
          margin: 0 auto -2mm;
        }
        @media print {
          .di-capa-print {
            width: 210mm;
            min-height: 297mm;
            margin: 0;
            padding: 16mm 14mm;
          }
          .di-capa-print,
          .di-capa-print * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}</style>

      <div className="di-capa-moldura">
        <div className="di-capa-empresa">
          <strong>{NOME_EMPRESA_LEGAL}</strong>
          Av. 17 - MORUMBY QD. OM-01 LT. 14, LUZIMANGUES, PORTO NACIONAL - TO<br />
          CNPJ: 37.780.886/0001-43 INSC. MUNICIPAL: 2420314<br />
          Fone: 63 98469 6099
        </div>

        <div className="di-capa-centro">
          <div className="di-capa-faixa">
            <span>RELAT&Oacute;RIO T&Eacute;CNICO</span>
          </div>
          <div className="di-capa-faixa di-capa-subtitulo">
            <span>DENSIDADE &quot;IN SITU&quot;</span>
          </div>

          <div className="di-capa-dados">
            <div className="di-capa-info">
              <strong>CLIENTE:</strong>
              <span>{valor(dados.empresa || dados.cliente)}</span>
            </div>
            <div className="di-capa-info">
              <strong>OBRA:</strong>
              <span>{valor(dados.obra)}</span>
            </div>
            <div className="di-capa-info">
              <strong>LOCAL:</strong>
              <span>{valor(localRelatorio)}</span>
            </div>
          </div>
        </div>

        <div className="di-capa-rodape">
          <img className="di-capa-assinatura-img" src="/Images/assinaturaLeal.png" alt="Assinatura" />
          <div className="di-capa-assinatura">
            Jos&eacute; Carlos Lemes Leal<br />
            Eng. Civil Esp. CREA 203379/D - TO
          </div>
          {formatarDataBR(dataBase)}
        </div>
      </div>
    </div>
  );
}

function RelatorioDensidadeInSituPagina({ dados = {}, ensaios = [], ultimaPagina = true }) {
  return (
    <div className={`relatorio-densidade-in-situ-print ${ultimaPagina ? "" : "di-quebra-pagina"}`}>
      <style>{`
        .relatorio-densidade-in-situ-print { page: relatorioDensidadeInSituPrint; }
        @page relatorioDensidadeInSituPrint { size: A4 portrait; margin: 0; }
        .relatorio-densidade-in-situ-print {
          width: 210mm;
          min-height: 297mm;
          margin: 0 auto 10mm;
          padding: 4mm 6mm 12mm;
          background: #fff;
          color: #000;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 10px;
          box-sizing: border-box;
          overflow: hidden;
        }
        .relatorio-densidade-in-situ-print table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          box-sizing: border-box;
        }
        .di-body-table {
          width: 100% !important;
        }
        .relatorio-densidade-in-situ-print td,
        .relatorio-densidade-in-situ-print th {
          border: 1px solid #000;
          padding: 1px 3px;
          height: 5.4mm;
          vertical-align: middle;
          font-weight: 400;
          text-align: center;
          overflow: hidden;
        }
        .di-header td {
          height: 7.8mm;
          padding: 1px 3px;
        }
        .di-header .di-header-meta {
          height: 5.4mm;
        }
        .di-logo {
          text-align: center;
        }
        .di-logo img {
          width: 38mm;
          max-height: 20mm;
          object-fit: contain;
        }
        .di-header-label {
          display: block;
          font-size: 8px;
          line-height: 1.1;
          text-align: left;
        }
        .di-header-value {
          display: block;
          font-size: 12px;
          line-height: 1.2;
          margin-top: 2px;
          text-align: left;
        }
        .di-header-title {
          font-size: 13px;
          line-height: 1.25;
          text-align: center;
        }
        .di-center {
          text-align: center !important;
        }
        .di-section {
          height: 6.5mm;
          text-align: center;
          font-weight: 700;
          font-size: 11px;
        }
        .di-side {
          writing-mode: vertical-rl;
          transform: rotate(180deg);
          text-align: center;
          font-weight: 700;
          font-size: 9px;
          padding: 1px;
        }
        .di-letter {
          text-align: center;
          font-weight: 700;
        }
        .di-label {
          text-align: left !important;
        }
        .di-unit {
          text-align: center;
          font-size: 9px;
        }
        .di-formula {
          text-align: center;
          font-size: 8px;
        }
        .di-id-label {
          border-right: 0 !important;
        }
        .di-id-unit {
          border-left: 0 !important;
          border-right: 0 !important;
        }
        .di-id-formula {
          border-left: 0 !important;
        }
        .di-localizacao td {
          height: 31mm;
        }
        .di-resultado td {
          height: 8mm;
        }
        .di-title {
          font-size: 13px;
          font-weight: 700;
          text-align: center;
        }
        .di-condicao {
          text-align: left;
          font-size: 7px;
          line-height: 1.35;
          padding: 1px 2px;
        }
        .di-condicao-linha {
          display: grid;
          grid-template-columns: 5mm 1fr;
          align-items: center;
          column-gap: 2mm;
          min-height: 6mm;
        }
        .di-check {
          display: inline-block;
          width: 5mm;
          height: 5mm;
          border: 1px solid #000;
          text-align: center;
          line-height: 5mm;
          font-size: 10px;
          font-weight: 700;
          box-sizing: border-box;
        }
        .di-obs {
          height: 48mm !important;
          min-height: 48mm !important;
          vertical-align: top !important;
          text-align: left !important;
          overflow: visible !important;
          line-height: 1.4;
        }
        .di-obs-row td {
          height: 48mm !important;
          min-height: 48mm !important;
        }
        .di-footer td {
          height: 12mm;
          vertical-align: top;
          text-align: left;
        }
        .relatorio-densidade-in-situ-print.di-quebra-pagina {
          page-break-after: always;
          break-after: page;
        }
        @media print {
          html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
          .relatorio-densidade-in-situ-print {
            width: 210mm;
            min-height: 297mm;
            margin: 0;
            padding: 4mm 6mm 12mm;
            page-break-after: always;
            break-after: page;
          }
          .relatorio-densidade-in-situ-print:not(.di-quebra-pagina) {
            page-break-after: auto;
            break-after: auto;
          }
          .relatorio-densidade-in-situ-print,
          .relatorio-densidade-in-situ-print * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .relatorio-densidade-in-situ-print table,
          .relatorio-densidade-in-situ-print tr,
          .relatorio-densidade-in-situ-print td,
          .relatorio-densidade-in-situ-print th {
            break-inside: avoid !important;
            page-break-inside: avoid !important;
          }
        }
      `}</style>

      <table className="di-header">
        <colgroup>
          <col style={{ width: "22%" }} />
          <col style={{ width: "46%" }} />
          <col style={{ width: "16%" }} />
          <col style={{ width: "16%" }} />
        </colgroup>
        <tbody>
          <tr>
            <td rowSpan="3" className="di-logo">
              <LogoRelatorio alt="Logo da empresa"  />
            </td>
            <td colSpan="2" className="di-center di-header-meta">
              SISTEMA DE GESTÃO DA QUALIDADE
            </td>
            <td className="di-center di-header-meta">RQ 2.1.2</td>
          </tr>
          <tr>
            <td rowSpan="2" colSpan="2" className="di-header-title">
              DENSIDADE "IN SITU" (frasco de areia)
            </td>
            <td className="di-center di-header-meta">Revisão 00</td>
          </tr>
          <tr>
            <td className="di-center di-header-meta">20/08/2025</td>
          </tr>
          <tr>
            <td colSpan="2">
              <span className="di-header-label">EMPRESA:</span>
              <span className="di-header-value">{valor(dados.empresa || dados.cliente)}</span>
            </td>
            <td colSpan="2">
              <span className="di-header-label">OBRA:</span>
              <span className="di-header-value">{valor(dados.obra)}</span>
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <span className="di-header-label">CAMADA/ESTUDO:</span>
              <span className="di-header-value">{valor(dados.camadaEstudo)}</span>
            </td>
            <td>
              <span className="di-header-label">OPERADOR</span>
              <span className="di-header-value di-center">{valor(dados.operador)}</span>
            </td>
            <td>
              <span className="di-header-label">CALCULISTA</span>
              <span className="di-header-value di-center">{valor(dados.calculista)}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <table className="di-body-table">
        <colgroup>
          <col style={{ width: "3%" }} />
          <col style={{ width: "3%" }} />
          <col style={{ width: "22%" }} />
          <col style={{ width: "7%" }} />
          <col style={{ width: "8%" }} />
          {Array.from({ length: ENSAIOS_POR_PAGINA }).map((_, index) => (
            <col key={index} style={{ width: "11.4%" }} />
          ))}
        </colgroup>
        <tbody>
          <tr>
            <td colSpan="10" className="di-section">DADOS DE IDENTIFICAÇÃO DO FURO</td>
          </tr>
          <tr>
            <td rowSpan="5" className="di-side">IDENTIFICAÇÃO DOS ENSAIOS</td>
            <td colSpan="2" className="di-label di-id-label">ENSAIO</td>
            <td className="di-unit di-id-unit">( N&deg; )</td>
            <td className="di-formula di-id-formula"></td>
            {celulasEnsaios(ensaios, "numero")}
          </tr>
          <tr className="di-localizacao">
            <td colSpan="4">LOCALIZAÇÃO</td>
            {celulasEnsaios(ensaios, "localizacao")}
          </tr>
          <tr>
            <td colSpan="2" className="di-label di-id-label">HORA</td>
            <td className="di-unit di-id-unit">( N&deg; )</td>
            <td className="di-formula di-id-formula"></td>
            {celulasEnsaios(ensaios, "hora")}
          </tr>
          <tr>
            <td colSpan="2" className="di-label di-id-label">CAMADA/COTA</td>
            <td className="di-unit di-id-unit">( elev. )</td>
            <td className="di-formula di-id-formula"></td>
            {celulasEnsaios(ensaios, "camadaCota")}
          </tr>
          <tr>
            <td colSpan="2" className="di-label di-id-label">PROFUNDIDADE</td>
            <td className="di-unit di-id-unit">( m )</td>
            <td className="di-formula di-id-formula"></td>
            {celulasEnsaios(ensaios, "profundidade")}
          </tr>

          <tr>
            <td colSpan="10" className="di-section">DETERMINAÇÃO DA DENSIDADE</td>
          </tr>
          <tr>
            <td rowSpan="14" className="di-side">DENSIDADE EM CAMPO</td>
            <td className="di-letter">-</td>
            <td className="di-label">FRASCO DE AREIA</td>
            <td className="di-unit">( N&deg; )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "frascoAreia")}
          </tr>
          <tr>
            <td className="di-letter">A</td>
            <td className="di-label">PESO INICIAL DO FRASCO</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "pesoInicialFrasco")}
          </tr>
          <tr>
            <td className="di-letter">B</td>
            <td className="di-label">PESO FINAL DO FRASCO</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "pesoFinalFrasco")}
          </tr>
          <tr>
            <td className="di-letter">C</td>
            <td className="di-label">PESO DESLOCADO</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">C= A-B</td>
            {celulasEnsaios(ensaios, "pesoDeslocado")}
          </tr>
          <tr>
            <td className="di-letter">D</td>
            <td className="di-label">PESO DA AREIA NO FUNIL</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "pesoAreiaFunil")}
          </tr>
          <tr>
            <td className="di-letter">E</td>
            <td className="di-label">PESO DA AREIA NO FURO</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">E=C-D</td>
            {celulasEnsaios(ensaios, "pesoAreiaFuro")}
          </tr>
          <tr>
            <td className="di-letter">F</td>
            <td className="di-label">DENSIDADE DA AREIA</td>
            <td className="di-unit">( g/cm&sup3; )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "densidadeAreia")}
          </tr>
          <tr>
            <td className="di-letter">G</td>
            <td className="di-label">VOLUME DO FURO</td>
            <td className="di-unit">( cm&sup3; )</td>
            <td className="di-formula">G=E/F</td>
            {celulasEnsaios(ensaios, "volumeFuro")}
          </tr>
          <tr>
            <td className="di-letter">H</td>
            <td className="di-label">PESO DO SOLO + TARA</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "pesoSoloTara")}
          </tr>
          <tr>
            <td className="di-letter">I</td>
            <td className="di-label">PESO DA TARA</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "pesoTara")}
          </tr>
          <tr>
            <td className="di-letter">J</td>
            <td className="di-label">PESO DO SOLO ÚMIDO</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">J=H-I</td>
            {celulasEnsaios(ensaios, "pesoSoloUmido")}
          </tr>
          <tr>
            <td className="di-letter">K</td>
            <td className="di-label">UMIDADE DO SOLO</td>
            <td className="di-unit">( % )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "umidadeSolo")}
          </tr>
          <tr>
            <td className="di-letter">L</td>
            <td className="di-label">PESO DO SOLO SECO</td>
            <td className="di-unit">( g. )</td>
            <td className="di-formula">L=J/(100+K)*100</td>
            {celulasEnsaios(ensaios, "pesoSoloSeco")}
          </tr>
          <tr>
            <td className="di-letter">M</td>
            <td className="di-label">DENS. DO SOLO SECO</td>
            <td className="di-unit">( g/cm&sup3; )</td>
            <td className="di-formula">M=L/G</td>
            {celulasEnsaios(ensaios, "densidadeSoloSeco")}
          </tr>

          <tr>
            <td colSpan="10" className="di-section">RESULTADOS DE COMPACTAÇÃO</td>
          </tr>
          <tr className="di-resultado">
            <td rowSpan="3" className="di-side">LABORATÓRIO</td>
            <td className="di-letter">N</td>
            <td className="di-label">DENSIDADE MÁXIMA</td>
            <td className="di-unit">( g/cm&sup3; )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "densidadeMaxima")}
          </tr>
          <tr className="di-resultado">
            <td className="di-letter">O</td>
            <td className="di-label">UMIDADE ÓTIMA</td>
            <td className="di-unit">( % )</td>
            <td className="di-formula">-</td>
            {celulasEnsaios(ensaios, "umidadeOtima")}
          </tr>
          <tr className="di-resultado">
            <td className="di-letter">P</td>
            <td className="di-label">GRAU DE COMPACTAÇÃO</td>
            <td className="di-unit">( % )</td>
            <td className="di-formula">P=(M/N)%</td>
            {celulasEnsaios(ensaios, "grauCompactacao")}
          </tr>

          <tr>
            <td colSpan="5" className="di-title">CONDIÇÃO</td>
            {celulasCondicao(ensaios)}
          </tr>
          <tr className="di-obs-row">
            <td colSpan="10" className="di-obs">
              OBS:<br />
              {valor(dados.observacao) === "-" ? "" : dados.observacao}
            </td>
          </tr>
          <tr className="di-footer">
            <td colSpan="4">LABORATÓRIO:<br />{valor(dados.laboratorio)}</td>
            <td colSpan="3">FISCALIZAÇÃO:<br />{valor(dados.fiscalizacao)}</td>
            <td colSpan="3">DATA:<br /><div className="di-center">{formatarDataBR(dados.dataEnsaio)}</div></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
